import React from 'react';

interface TicketSelectAllCheckboxProps {
  isAllSelected: boolean;
  isIndeterminate: boolean;
  onToggleAll: () => void;
  disabled?: boolean;
}

export const TicketSelectAllCheckbox: React.FC<TicketSelectAllCheckboxProps> = ({
  isAllSelected,
  isIndeterminate,
  onToggleAll,
  disabled = false
}) => {
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        checked={isAllSelected}
        ref={(input) => {
          if (input) {
            input.indeterminate = isIndeterminate;
          }
        }}
        onChange={onToggleAll}
        disabled={disabled}
        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
      />
    </div>
  );
};
